import { writable, readable } from "svelte/store";

export const appSession = writable({
  authorisationToken: null,
  pilotId: null,
});

export const account = writable({
  name: null,
  email: null,
  subscriptionRequired: false,
  subscriptionExpired: false,
});

export const appConstants = readable({
//  apiURLBase: "http://www.jumphub.test/api/v1/",
//  apiURLBase: "https://api.jumphub.aero/api/v1/", 
  apiURLBase: "https://testapi.jumphub.aero/api/v1/", 
  version: "1027",
  pendingRequestLimit: 5
});
